import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

const ProtectedRoute = ({ children, requireAuth = true, requiredRole = null }) => {
  const { user, loading, isAuthenticated } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  // If authentication is required but user is not logged in
  if (requireAuth && !isAuthenticated) {
    // If trying to access /apply, redirect to welcome page
    if (location.pathname === '/apply') {
      return <Navigate to="/apply-welcome" replace />;
    }
    // Otherwise redirect to login
    return <Navigate to="/login" replace />;
  }

  // If a specific role is required
  if (requiredRole && user?.role !== requiredRole && user?.role !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
